import type { Site } from '@/api/fe-api/domain/entities/site';
import { GetAllCommunications } from '@/api/fe-api/view/queries/get-all-communications';

import { useDetailsId } from '../hooks/use-details-id';
import { useListFilters } from '../hooks/use-list-filters';
import { CommunicationCurrentSiteProvider } from '../providers/current-site';

import { CommunicationDetailsEmail } from './communication-details-email';
import { CommunicationDetailsEmpty } from './communication-details-empty';
import { CommunicationDetailsMeeting } from './communication-details-meeting';
import { CommunicationEmpty } from './communication-empty';
import { CommunicationShell } from './communication-shell';
import { CommunicationSidebar } from './communication-sidebar';

export type CommunicationProps = { site?: Site };

export function Communication({ site }: CommunicationProps) {
  const [filters] = useListFilters();
  const listResult = GetAllCommunications.useInfiniteQuery({
    ...filters,
    ...(site ? { siteIds: [site.id] } : undefined),
  });
  const allFiltersResult = GetAllCommunications.useInfiniteQuery({});

  if (
    allFiltersResult.isSuccess &&
    allFiltersResult.data?.pages.at(0)?.totalCount === 0
  ) {
    return <CommunicationEmpty />;
  }

  return (
    <CommunicationCurrentSiteProvider site={site}>
      <CommunicationShell
        sidebar={<CommunicationSidebar listResult={listResult} />}
      >
        <CommunicationDetails />
      </CommunicationShell>
    </CommunicationCurrentSiteProvider>
  );
}

function CommunicationDetails() {
  const [detailsId] = useDetailsId();

  switch (detailsId?.type) {
    case 'email':
      return <CommunicationDetailsEmail id={detailsId.id} />;
    case 'meeting': {
      return <CommunicationDetailsMeeting id={detailsId.id} />;
    }
    default: {
      return <CommunicationDetailsEmpty />;
    }
  }
}
